import { FC, useContext, useMemo } from "react";
import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import classNames from "classnames";
import SidebarMainNavigation from "../common/main-navigation/SidebarMainNavigation";
import { SidebarContext } from "../Sidebar";
import styles from "./advanced-sidebar.module.sass";
import AdvancedSidebarCasino from "./casino/AdvancedSidebarCasino";
import AdvancedSidebarLive from "./live/AdvancedSidebarLive";
import AdvancedSidebarPrematch from "./prematch/AdvancedSidebarPrematch";
import AdvancedSidebarFooter from "./footer/AdvancedSidebarFooter";

type IProps = {
    animate: boolean;
};

const AdvancedSidebar: FC<IProps> = ({ animate }) => {
    const { viewType } = useContext(SidebarContext);

    const renderView = useMemo(() => {
        let content = null;
        switch (viewType) {
            case "sport":
                content = (
                    <ErrorBoundary name={AdvancedSidebarPrematch.name}>
                        <AdvancedSidebarPrematch />
                    </ErrorBoundary>
                );
                break;
            case "live":
                content = (
                    <ErrorBoundary name={AdvancedSidebarLive.name}>
                        <AdvancedSidebarLive />
                    </ErrorBoundary>
                );
                break;
            case "casino":
                content = (
                    <ErrorBoundary name={AdvancedSidebarCasino.name}>
                        <AdvancedSidebarCasino />
                    </ErrorBoundary>
                );
                break;
            default:
                content = null;
        }

        if (!content) {
            return null;
        }

        return <>{content}</>;
    }, [viewType]);

    return (
        <div className={styles.advancedSidebar}>
            <SidebarMainNavigation />
            <div className={classNames(styles.content, animate && styles.animate)}>
                {renderView}
                <AdvancedSidebarFooter />
            </div>
        </div>
    );
};

export default AdvancedSidebar;
